jQuery(document).ready(($) => {

    var vid = $('.home-video-area video');

    $(".vidbg-controller").on("click", playPause);


    function playPause() { 
        if (vid.get(0).paused){
            vid.get(0).play();
            $(".vidbg-controller").removeClass().addClass('vidbg-controller fa fa-pause');
        } 
        else {
            vid.get(0).pause(); 
            $(".vidbg-controller").removeClass().addClass('vidbg-controller fa fa-play');
        }
    } 

});